import React, { Fragment } from 'react';
import { Form } from 'antd';
import { ModalFooter, TextArea } from 'src/components/Antd';

import css from './css.module.less';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
const MarkAsPaid = ({ onModalCancel, onMarkAsPaidConfirm }) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const [form] = Form.useForm();
  return (
    <Fragment>
      <Form
        onFinish={onMarkAsPaidConfirm}
        form={form}
        className={css.modalContain}>
        <p>{getI18n('allOrders.orderDetail.mark_as_paid_modal_contain')}</p>

        <Form.Item
          name='reason'
          labelCol={{ span: 24 }}
          label={`${getI18n(
            'allOrders.orderDetail.externalReference',
          )}(${getI18n('general.optional')})`}>
          <TextArea size='large' maxLength='100' />
        </Form.Item>
      </Form>
      <ModalFooter
        onOk={() => form.submit()}
        okText={getI18n('general.confirm')}
        cancelText={getI18n('general.cancel')}
        onCancel={onModalCancel}
      />
    </Fragment>
  );
};

export default MarkAsPaid;
